'use client';
import React from 'react';
import Slider from 'react-slick';

const TechnicalApproachVisionMultimodal: React.FC = () => {
    const technicalapproach = {
        dots: true,
        arrow: true,
        autoplay: false,
        speed: 500, // Set slide transition speed
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <>
            <section className="section-py case-study relative overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <video playsInline autoPlay muted loop className="aimlvideo w-full h-full object-cover">
                        <source src="media/video-vision-multimodal-ai.mp4" type="video/mp4" />
                    </video>
                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 pointer-events-none bg-video-gradient"></div>
                </div>
                <div className="container lg:container md:mx-auto relative z-[1]">
                    <div className="row grid lg:grid-cols-12 mb-50">
                        <div className="lg:col-span-10">
                            <h2 className="mb-2.5 text-white">
                                How We Build: <span className="gradient-text">Technical Approach</span>
                            </h2>
                            <p className="mb-0 fw-600 text-[#D7DEE5]">
                                We combine state-of-the-art pre-trained models with domain-specific fine-tuning to deliver production-ready computer vision systems fast. Our process includes:
                            </p>
                        </div>
                    </div>

                    <div className="section pb-16 case-study-slider-img case-study-slider-aiml technical-approach-slider aienabled-fintech-slider">
                        <div className="container-fluid lg:container-fluid mx-auto">
                            <Slider {...technicalapproach} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-discovery-design bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                   Data Strategy
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[150px]">
                                                    Building accurate annotation pipelines, enriching datasets through augmentation, and generating synthetic data to improve model resilience.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-data-preparation bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Model Selection
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[150px]">
                                                    Utilizing top models like YOLO for rapid object detection, SAM for flexible segmentation, CLIP and Florence for vision-language tasks, and Detectron2 for advanced segmentation, alongside custom model development when required.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-rag-architecture bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                   Multimodal Fusion
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[150px]">
                                                    Integrating visual encoders with large language models (e.g., CLIP + GPT, LLaVA) to enable deep understanding across vision and language modalities.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-prompt-engineering bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Optimization
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[150px]">
                                                    Applying model quantization, pruning, and conversion to ONNX/TensorRT for low-latency edge deployment.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-fine-tuning bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                   Integration
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[150px]">
                                                    Developing REST APIs and streaming pipelines for seamless real-time inference on edge or cloud systems.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-integration-testing bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Governance
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[150px]">
                                                  Ensuring transparency and fairness with bias detection, explainability tools, and audit trails to meet regulatory requirements.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default TechnicalApproachVisionMultimodal;
